<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="mb-0">Вебинары</h1>
    </div>
    <br>

    <table class="table table-borderless" v-if="webinars && webinars.length > 0">
      <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">Название вебинара</th>
          <th scope="col">Дата</th>
          <th scope="col">Статус</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(webinar, index) in webinars" :key="webinar.id">
          <td>{{ index + 1 }}</td>
          <td><a href="#" @click.prevent="openEditModal(webinar)">{{ webinar.title }}</a></td>
          <td>{{ webinar.date }}</td>
          <td>{{ webinar.isActive }}</td>
          <td><a href="#" @click.prevent="openEditModal(webinar)"><img src="/static/images/icons/edit.svg" alt=""></a></td>
        </tr>
      </tbody>
    </table>
    <br>
    <p class="text-center">
      <a href="#" @click.prevent="openEditModal(false)" class="btn bg-lighter">
        Добавить вебинар
      </a>
    </p>
    <hr class="space space-sm">
    <webinar-add ref="modal" :item="editWebinar" @update="update"></webinar-add>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import WebinarAdd from './Includes/WebinarAddModal'

export default {
  name: 'webinars',
  components: {
    webinarAdd: WebinarAdd
  },
  data () {
    return {
      editWebinar: null
    }
  },
  computed: {
    ...mapState({
      webinars: state => state.managers.webinars
    })
  },
  methods: {
    openEditModal (item) {
      if (item) {
        this.editWebinar = item
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      } else {
        this.editWebinar = null
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      }
    },
    update () {
      this.$store.dispatch('GET_WEBINAR', this.editWebinar.slug)
      this.$refs.modal.hideModal()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('GET_WEBINARS')

    if (this.user && !this.user.isAdmin) {
      this.$router.push({ name: 'profile' })
    }
  }
}
</script>